import React from 'react';
import { Checkbox, Divider, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

import styles from '../styles.module.scss';
import { ICase } from '@brands/services/cases/types/ICase';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import { OralHealthReportSubmit } from '@brands/Dashboard/ConsultationPage/assets/types';
import { FieldErrors } from 'react-hook-form';

type Props = {
  thisCase: ICase;
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => Promise<void>;
  errors: FieldErrors<OralHealthReportSubmit>;
};

const AppointmentChecklistCard = ({ thisCase, checked, disabled, onChange, errors }: Props): JSX.Element => {
  const termsError = errors.is_terms_accepted?.message;
  const patientDob = thisCase.patient?.basic_info?.date_of_birth;
  const patientCurrentLocation = thisCase.patient_current_state || '—';

  return (
    <div className={styles.consultationPageRightSideFrameCaseDetails}>
      <div className={styles.consultationPageRightSideFrameCaseDetailsTitle}>
        <span>
          Appointment checklist <span className={styles.consultationPageRightSideFrameCaseDetailsTitleRequired}>*</span>
        </span>
        <Divider orientation="horizontal" flexItem className={styles.divider} />
      </div>

      <div className={styles.consultationPageRightSideFrameCaseDetailsList}>
        <ul className={styles.caseDetailsList}>
          <li>My identity, jurisdiction, and licensure status are visible to the patient in my profile</li>
          <li>Patient location is within provider’s licensure jurisdiction</li>
          <li>The following patient details are correct:</li>
        </ul>

        <div className={styles.appointmentChecklistDetails}>
          <div>
            <span className={styles.header}>Name</span>
            <span className={styles.value}>{thisCase.patient?.full_name ?? '—'}</span>
          </div>

          {!isMobile && <Divider orientation="vertical" flexItem className={styles.divider} />}

          <div className={styles.appointmentChecklistDetailsMobile}>
            <div>
              <span className={styles.header}>Current location</span>
              <span className={styles.value}>{patientCurrentLocation}</span>
            </div>

            <Divider orientation="vertical" flexItem className={styles.divider} />

            <div>
              <span className={styles.header}>DOB</span>
              <span className={styles.value}>{patientDob ? moment(patientDob).format('MM/DD/YYYY') : '-'}</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.consultationPageRightSideFrameCaseDetailsCheckbox}>
        <FormControl error={!!termsError}>
          <FormControlLabel
            disabled={disabled}
            control={
              <Checkbox
                checked={checked}
                sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 20,
                    width: '28px',
                    height: '28px',
                  },
                  '&.Mui-checked .MuiSvgIcon-root': {
                    fill: 'var(--primary-color)',
                  },
                  ...(termsError && {
                    color: '#d32f2f',
                    '&.Mui-checked': {
                      color: '#d32f2f',
                    },
                  }),
                }}
                onChange={(event) => {
                  void onChange(event.target.checked);
                }}
              />
            }
            label="I have verified the above information is correct"
          />

          {termsError && (
            <FormHelperText>
              {typeof termsError === 'string' ? termsError : 'You must verify that the information is correct'}
            </FormHelperText>
          )}
        </FormControl>
      </div>
    </div>
  );
};

export default AppointmentChecklistCard;
